import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { ICON_TYPE } from "utils/constants";
import "./style.scss"
import { Toast } from "components/ToastShow/ToastAlert";
import { trans } from "utils/helpers";

interface BrowseFileProp {
    onChange?: (event) => void;
    accept?:any;
    multiple?: any;
    disabled?: any;
    fileClick?:any
    showBox?:any
    required?:any
    setFileClick?: (event) => void;
    value?:any
}
export const BrowseFile = ({setFileClick ,fileClick,value='',showBox,disabled ,required,accept, onChange ,multiple=false, ...rest}: BrowseFileProp) => {
    const uploadRef = useRef<HTMLInputElement>(null)
    const [fileName, setFileName] = useState<any>();
    let lang = localStorage.getItem("DefaultLanguage");
    
    const handleUploadOnclick = () => {
        uploadRef.current!.click()
    }
    useEffect(() => {
      if (fileClick){
        handleUploadOnclick()
        setFileClick && setFileClick(false)
      }
          
  }, [fileClick])

  return (
    <div className=" fileBrowse mt-0">
        <input 
          required={required}
          accept={accept}
          {...rest}
          style={{ display:"none"}}
          type='file'
          ref={uploadRef}
          disabled={disabled}
          onChange={(e)=>{   console.log("uploadRef?.current?.files",e?.target?.files?.[0].name) ;onChange&&onChange(e);setFileName(e?.target?.files?.[0].name)}  }
          multiple={multiple}
          value={value}
        />   
        
        { !showBox&& {
    "fa":(
        <>
        {!multiple &&
            <input
            disabled={disabled}

            required={required}
              placeholder={trans("NoFileSelected")}
              readOnly={true}
              value={ fileName}
              style={{ fontSize:"18px" , width:"unset"}}
              type="text"
              className={`fileBrowseInputFa ${disabled&&"disabled"} text-box__box` }
             />
        }
        <button  disabled={disabled}style={{ boxShadow: "none",width:"90px"  , height:"32px"}}  type={`button`} className={`btn-primary button-custom mx-1 btn `} onClick={handleUploadOnclick}>
            {trans("SelectFile") }
        </button>
        </>              
              
          ),
     "en": (
        <>
        {!multiple &&
            <input
            disabled={disabled}

            required={required}
              placeholder={trans("NoFileSelected")}
              readOnly={true}
              value={ uploadRef?.current?.files?.[0]?.name ?uploadRef?.current?.files[0]?.name: ""}
              style={{ fontSize:"18px" , width:"unset"}}
              type="text"
              className={`fileBrowseInputEn ${disabled&&"disabled"} text-box__box` }
            />
        }
        <button    disabled={disabled} style={{ boxShadow: "none",width:"90px" }}  type={`button`} className={`btn-primary button-custom mx-1 btn `} onClick={handleUploadOnclick}>
              {trans("SelectFile") }
        </button>
        </>
     )
    }[lang as string]}
    </div>
  );
};
